const handleReArchive = (loaderdiv, loaderOverlaydiv, axios, accessToken, createDialogBox, closeDialogBox, downloadImages, listThumbnails, setDownloadImages,setArchivedImages,setListThumbnails,setIsCheck,setIsCheckAll) => {
   
    let rehydrateApiUrl = process.env.REACT_APP_FUNCTION_APP_REHYDRATE_API_URL;
    
    const MAX_IMAGES = 250;
    // Filter out images where isFileArchived is "false"
    const archivedDownloadImages = downloadImages.filter(
        (item) => item.isFileArchived === "true"
    );

    // Check if there are more than 30 images
    let displayImages = archivedDownloadImages;
    let maxImagesMessage = null;
    if (archivedDownloadImages.length > MAX_IMAGES) {
        displayImages = archivedDownloadImages.slice(0, MAX_IMAGES);
        maxImagesMessage = {
            type: "p",
            text: "Max " + MAX_IMAGES + " images can be restored at a time.",
            attributes: { id: "max-images-info" },
        };
    }

    const cleanedDownloadImages = displayImages.map((item) => {
        const baseUrl = item.image.split("$")[0];
        return baseUrl.split("?")[0]; // removes SAS token
    });

    const arrayOfrehydratefiles = [...cleanedDownloadImages, ...listThumbnails];

    const elements = [
        {
            type: "input",
            attributes: {
                type: "text",
                id: "rearchive-reason",
                placeholder: "Enter reason here...",
            },
        },
        {
            type: "p",
            text: "NOTE:- Restoring from archive takes approximately 15 hours.",
            attributes: { id: "archiving-info" },
        },
    ];

    if (maxImagesMessage) {
        elements.splice(2, 0, maxImagesMessage);
    }

    if (
        downloadImages.some(
            (item) =>
                item.isFileArchived === "false" || item.isFileArchived === null
        )
    ) {
        elements.splice(3, 0, {
            type: "p",
            text: "The files that are not archived are excluded from the list.",
            attributes: { id: "excluded-files-info" },
        });
    }

    elements.splice(4, 0, {
        type: "button",
        text: "Submit",
        attributes: {
            id: "dialog-box-submit-button",
            // disabled: true,
        },
        listener: {
            event: "click",
            callback: () => {
                const rehydrationreason = "CCTV: " + document
                    .getElementById("rearchive-reason")
                    .value.trim();
                // console.log("reason: " + rehydrationreason);
                if (!rehydrationreason) {
                    alert("Please enter a reason.");
                    return;
                }
                const cleanedArrayOfrehydratefiles = arrayOfrehydratefiles.filter(
                    (file) => file.trim() !== ""
                );
                const payload = {
                    arrayOfrehydratefiles: cleanedArrayOfrehydratefiles,
                    rehydrationreason,
                };
                // console.log(payload);
                loaderdiv.style.visibility = "visible";
                loaderOverlaydiv.style.display = "flex";
                axios
                    .post(rehydrateApiUrl, payload, {
                        headers: {
                            Authorization: `Bearer ${accessToken}`,
                            "Content-Type": "application/json",
                        },
                    })
                    .then((response) => {
                        // console.log(payload);
                        loaderdiv.style.visibility = "hidden";
                        loaderOverlaydiv.style.display = "none";
                        // Show a success dialog box
                        createDialogBox(
                            "Success",
                            "Restoration process for selected files started successfully. Please come back after 15 hours to see the restored file.",
                            [],
                            closeDialogBox
                        );
                        // Clear the states for downloadImages and listThumbnails
                        setDownloadImages([]);
                        setArchivedImages([]);
                        setListThumbnails([]);
                        setIsCheck([]);
                        setIsCheckAll(false);
                    })
                    .catch((error) => {
                        // Show an error dialog box
                        loaderdiv.style.visibility = "hidden";
                        loaderOverlaydiv.style.display = "none";
                        let errorMessage = "Error re-archiving files: " + error;
                        if (error.response && error.response.status === 401) {
                            errorMessage =
                                "Token Expired! Please load page again from Salesforce.";
                        } else if (error.response.status === 500) {
                            errorMessage = "Internal Server Error! Please try again.";
                        }
                        createDialogBox("Error", errorMessage, [], closeDialogBox);
                        // Clear the states even on error
                        setDownloadImages([]);
                        setArchivedImages([]);
                        setListThumbnails([]);
                        setIsCheck([]);
                    });
                closeDialogBox();
            },
        },
    });

    createDialogBox(
        "Restoring from archive",
        "Please provide the reason for restoring from archive:-",
        elements,
        closeDialogBox
    );

    // const reasonInput = document.getElementById("rearchive-reason");
    // const submitButton = document.getElementById("dialog-box-submit-button");

    // reasonInput.addEventListener("input", () => {
    //   submitButton.disabled = reasonInput.value.trim() === "";
    // });
};

export default handleReArchive;